import {
  Auth0ContextInterface,
  AuthorizationParams,
  User,
  useAuth0,
} from '@auth0/auth0-react'
import useLoggedNavigate from 'hooks/useLoggedNavigate'
import { useEffect, useState } from 'react'
import LoginService from 'services/login-service'

export type TAccessTokenRequest = {
  authContext: Auth0ContextInterface<User>
} & AuthorizationParams

export type TAccessTokenResponse = {
  accessToken: string | null
  expires: Date
}

export function useAccessToken(request?: Partial<TAccessTokenRequest>) {
  const [accessToken, setAccessToken] = useState<string | null>(null)

  if (request == null) {
    request = {}
  }

  if (request.authContext == null) {
    request.authContext = useAuth0()
  }

  if (request.audience == null) {
    request.audience = `${process.env.REACT_APP_AUTH0_AUDIENCE}`
  }

  useEffect(() => {
    async function handleAccessToken() {
      const token = await getAccessToken(request as TAccessTokenRequest)
      setAccessToken(token.accessToken)
      LoginService.setTokens(token.accessToken, null, token.expires)
    }

    handleAccessToken()
  }, [request.authContext.isAuthenticated, request.authContext.isLoading])

  return accessToken
}

export async function getAccessToken(request: TAccessTokenRequest) {
  let accessToken: TAccessTokenResponse = {
    accessToken: '',
    expires: new Date(0),
  }

  if (!request.authContext.isAuthenticated && !request.authContext.isLoading) {
    return accessToken
  }

  try {
    const accessTokenResponse =
      await request.authContext.getAccessTokenSilently({
        authorizationParams: request,
        cacheMode: 'on',
        detailedResponse: true,
      })

    accessToken = {
      accessToken: accessTokenResponse?.access_token || null,
      expires: new Date((accessTokenResponse?.expires_in || 0) + Date.now()),
    }
  } catch (err) {
    if (
      err &&
      typeof err == 'object' &&
      'message' in err &&
      typeof err.message == 'string' &&
      err.message.toLowerCase().includes('consent')
    ) {
      try {
        await request.authContext.getAccessTokenWithPopup({
          authorizationParams: request,
          cacheMode: 'on',
        })

        const accessTokenResponse =
          await request.authContext.getAccessTokenSilently({
            authorizationParams: request,
            cacheMode: 'on',
            detailedResponse: true,
          })

        accessToken = {
          accessToken: accessTokenResponse?.access_token || null,
          expires: new Date(
            (accessTokenResponse?.expires_in || 0) + Date.now()
          ),
        }
      } catch (err2) {
        // if (window.location.href.endsWith(unauthorizedAccessPage.path)) {
        // 	//Do not automatically login when redirected to unauthorized page, as this gives additional information following an unauthorized but successful login.
        // 	return;
        // }

        window.location.href = `${window.location.origin}/unauthorized`

        // await request.authContext.logout()
        // await request.authContext.loginWithRedirect()
      }
    }

    if (
      err &&
      typeof err == 'object' &&
      'message' in err &&
      typeof err.message == 'string' &&
      err.message.includes('Login required')
    ) {
      // if (window.location.href.endsWith(unauthorizedAccessPage.path)) {
      // 	//Do not automatically login when redirected to unauthorized page, as this gives additional information following an unauthorized but successful login.
      // 	return;
      // }
      window.location.href = `${window.location.origin}/unauthorized`
      // await request.authContext.logout()
      // await request.authContext.loginWithRedirect()
    }
  }

  return accessToken
}
